/**
 * Sets the corner radius on Razorpay's Magic Checkout button.
 *
 * The button is a <magic-checkout-btn> custom element whose internals sit in a
 * CLOSED shadow root, so no CSS of ours can reach them. It does however observe
 * a "border-radius" attribute on the host element (light DOM) and copy it onto
 * the inner button itself - that is the only supported way in, so we use it.
 *
 * The element is injected after page load, and can be re-created (e.g. on
 * variant change), so we keep watching rather than setting this once.
 */
(() => {
  /* Razorpay splices this straight into "border-radius: <value>;" without
     adding units, so it has to be a complete CSS length. A bare "6" would be
     invalid and silently fall back to their 4px default. */
  const RADIUS = '6px';

  const apply = (el) => {
    // Guard the write: setting an attribute to its current value would loop
    // the observer via attributeChangedCallback.
    if (el.getAttribute('border-radius') !== RADIUS) {
      el.setAttribute('border-radius', RADIUS);
    }
  };

  const scan = () => {
    document.querySelectorAll('magic-checkout-btn').forEach(apply);
  };

  scan();

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
